import { render, staticRenderFns } from "./folderCount.vue?vue&type=template&id=0553cd0c"
import script from "./folderCount.vue?vue&type=script&lang=js"
export * from "./folderCount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports